import React, { useState, useEffect } from 'react'
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from '@mui/material'
import { useStyles } from '../CaseDiagnosisStyles'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { getBarcodeData, getDraftReportData, getSummaryTreeData } from '../../../actions'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'

export default function SlideDetails({ isLoading, location, trfBarcode, handleViewerOpen }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const sampleData = useSelector((state: RootState) => state.addSummaryTreeData)
  const sampleInfoTree = useSelector((state: RootState) => state.addSampleLocationData)
  const { procedureCodeId } = useSelector((state: RootState) => state.getCaseData)
  const { role, multiple_classifiers_allowed } = useSelector((state: RootState) => state.userLogin)
  const [isStain, setStain] = useState('')
  const [isBarcode, setBarcode] = useState('')
  const saveState = useSelector((state: RootState) => state.getSaveState)
  const [isConfirmDialogOpen, setConfirmDialogOpen] = useState(false)

  const getVisibilityIconClassName = (inactiveReason) =>
    inactiveReason === null ? classes.notDiagnosedIcon : classes.disabledDiagnosedIcon
  const getClassName = (isDiagnosed, inactiveReason) =>
    inactiveReason === null
      ? isDiagnosed && isDiagnosed === true
        ? `${classes.stainNameLeft}`
        : `${classes.notDiagnosedStainNameLeft}`
      : `${classes.disabledLink}`

  useEffect(() => {
    if (isStain) {
      setStain(isStain)
      console.log('stain added', isStain)
    }
    if (isBarcode) {
      setBarcode(isBarcode)
      console.log('barcode added', isBarcode)
    }
  }, [isStain, isBarcode])

  const handleSlideClick = async (slide, stain) => {
    dispatch(getDraftReportData({ trfBarcode: trfBarcode }))
    if (location) {
      const currentSelection = location
      const currentLocationData = sampleInfoTree['payload'].filter((item) => item.location === currentSelection)
      const currentLocation = currentLocationData[0]
      const stains: any[] = []
      if (currentLocation && currentLocation.children && currentLocation.children.length > 0) {
        currentLocation.children.map((slide) => {
          if (
            slide.type === 'expandable' &&
            slide.children &&
            slide.children.length > 0 &&
            slide.children[0].type === 'expandable' &&
            slide.children[0].children.length > 0
          ) {
            slide.children[0].children?.map((subChild, index1) => {
              const name =
                subChild.sampleBarcode +
                ' ' +
                (subChild.sampleStain ? subChild.sampleStain : subChild.children[0].sampleStain)
              const type = subChild.type
              const isDiagnosed = subChild.isDiagnosed === null ? false : subChild.isDiagnosed
              const isDontReport = subChild.isDontReport === null ? false : subChild.isDontReport
              stains.push({
                name: name,
                type: type,
                isDiagnosed: isDiagnosed,
                isDontReport: isDontReport,
              })
            })
          } else if (slide.type === 'expandable' && slide.children && slide.children.length > 0) {
            slide.children?.map((subChild, index2) => {
              const name = subChild.sampleBarcode + ' ' + subChild.sampleStain
              const type = subChild.type
              const isDiagnosed = subChild.isDiagnosed === null ? false : subChild.isDiagnosed
              const isDontReport = subChild.isDontReport === null ? false : subChild.isDontReport
              stains.push({
                name: name,
                type: type,
                isDiagnosed: isDiagnosed,
                isDontReport: isDontReport,
              })
            })
          } else if (slide.type === 'checkbox') {
            const name = slide.sampleBarcode + ' ' + slide.sampleStain
            const type = slide.type
            const isDiagnosed = slide.isDiagnosed === null ? false : slide.isDiagnosed
            const isDontReport = slide.isDontReport === null ? false : slide.isDontReport
            stains.push({
              name: name,
              type: type,
              isDiagnosed: isDiagnosed,
              isDontReport: isDontReport,
            })
          }
        })
        await dispatch(
          getSummaryTreeData({
            trfBarcode: trfBarcode,
            location: location,
            procedureCode: procedureCodeId,
          }),
        )
        await dispatch(
          getBarcodeData({
            trfBarcode: trfBarcode,
            slide: slide,
            multiple_classifiers_allowed: multiple_classifiers_allowed,
          }),
        )
        handleViewerOpen({
          slide: slide,
          stain: stain,
          location: location,
          trfBarcode: trfBarcode,
          stainData: stains,
          isShow: false,
        })
      }
    }
  }

  const handleConfirmDialogOpen = (barcode, stain) => {
    if (saveState && saveState.payload === false && role !== 'NL_WOMA_ADMIN') {
      setBarcode(barcode)
      setStain(stain)
      setConfirmDialogOpen(true)
    } else {
      handleSlideClick(barcode, stain)
    }
  }

  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false)
  }

  const handleConfirm = () => {
    handleSlideClick(isBarcode, isStain)
  }

  return (
    <Box className={classes.slideDetails}>
      <div className={classes.slideDetailsTitle}>Slide Diagnosis</div>
      <div className={classes.slidesWrapper}>
        {isLoading ? (
          <CircularProgress className={classes.slidesLoadingIndicator} />
        ) : (
          <TableContainer component={Paper} style={{ boxShadow: 'none' }}>
            <Table aria-label="customized table">
              <TableBody>
                {sampleData &&
                  sampleData.payload &&
                  sampleData.payload.length > 0 &&
                  sampleData.payload.map(
                    (sample, index1) =>
                      sample.Stain !== null && (
                        <TableRow key={index1}>
                          <TableCell style={{ width: '100%', padding: '5px' }}>
                            {sample.isDiagnosed === null && (
                              <Tooltip title="Not diagnosed" placement="top-start">
                                <VisibilityIcon className={getVisibilityIconClassName(sample.inactiveReason)} />
                              </Tooltip>
                            )}
                            {sample.isDontReport && sample.isDiagnosed && (
                              <Tooltip title="Do not report" placement="top-start">
                                <CancelRoundedIcon className={classes.excludeIcon} />
                              </Tooltip>
                            )}
                            {!sample.isDontReport && sample.isDiagnosed && (
                              <Tooltip title="Diagnosed" placement="top-start">
                                <CheckCircleRoundedIcon className={classes.includeIcon} />
                              </Tooltip>
                            )}
                            <label
                              className={getClassName(sample.isDiagnosed, sample.inactiveReason)}
                              onClick={() => handleConfirmDialogOpen(sample.Barcode, sample.Stain)}
                            >
                              {sample.Stain.toUpperCase()}
                            </label>
                            <br />
                            <span style={{ paddingLeft: '20%' }}>{sample.Barcode}</span>
                          </TableCell>
                          <TableCell>
                            {Object.keys(sample).map(
                              (key, index) =>
                                key !== 'Barcode' &&
                                key !== 'type' &&
                                key !== 'Stain' &&
                                key !== 'isDontReport' &&
                                key !== 'isDiagnosed' &&
                                key !== 'inactiveReason' &&
                                sample[key] !== null && (
                                  <>
                                    <label className={classes.stainDetailType} key={index}>
                                      {key}
                                    </label>
                                    <br />
                                    <label className={classes.stainDetailDescription}>
                                      {sample[key] ? sample[key] : '[]'}
                                    </label>
                                    {index != Object.keys(sample).length - 1 && <br />}
                                  </>
                                ),
                            )}
                          </TableCell>
                        </TableRow>
                      ),
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
      <Dialog
        open={isConfirmDialogOpen}
        onClose={handleConfirmDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{ paper: classes.discardDialogHeight }}
      >
        <DialogTitle className={classes.dialogTitle}>Discard Changes</DialogTitle>
        <DialogContent className={classes.discardDialogContent}>
          <DialogContentText id="alert-dialog-description">
            You have pending unsaved changes. Do you really want to discard them?
          </DialogContentText>
        </DialogContent>

        <DialogActions className={classes.buttonActions}>
          <Button className={classes.saveButton} onClick={handleConfirm} autoFocus endIcon={<CheckIcon />}>
            Confirm
          </Button>
          <Button
            className={`${classes.buttonMargin}`}
            onClick={handleConfirmDialogClose}
            variant="outlined"
            endIcon={<ClearIcon />}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
